var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1111 6.44444H17.3333C16.8422 6.44444 16.4444 6.04667 16.4444 5.55556V2.88889C16.4444 2.39778 16.8422 2 17.3333 2H18.2222C19.204 2 20 2.796 20 3.77778V5.55556C20 6.04667 19.6022 6.44444 19.1111 6.44444ZM4.88889 6.44444H6.66667C7.15778 6.44444 7.55556 6.04667 7.55556 5.55556V2.88889C7.55556 2.39778 7.15778 2 6.66667 2H5.33333C4.35156 2 4 2.796 4 3.77778V5.55556C4 6.04667 4.39778 6.44444 4.88889 6.44444ZM19.1111 13.5556H17.3333C16.8422 13.5556 16.4444 13.9533 16.4444 14.4444V17.1111C16.4444 17.6022 16.8422 18 17.3333 18H18.2222C19.204 18 20 17.204 20 16.2222V14.4444C20 13.9533 19.6022 13.5556 19.1111 13.5556ZM4.88889 13.5556H6.66667C7.15778 13.5556 7.55556 13.9533 7.55556 14.4444V17.1111C7.55556 17.6022 7.15778 18 6.66667 18H5.77778C4.796 18 4 17.204 4 16.2222V14.4444C4 13.9533 4.39778 13.5556 4.88889 13.5556ZM10.4444 12.2222H4.88889C4.39778 12.2222 4 11.8244 4 11.3333V8.66667C4 8.17556 4.39778 7.77778 4.88889 7.77778H10.4444C10.9356 7.77778 11.3333 8.17556 11.3333 8.66667V11.3333C11.3333 11.8244 10.9356 12.2222 10.4444 12.2222ZM19.1111 12.2222H13.5556C13.0644 12.2222 12.6667 11.8244 12.6667 11.3333V8.66667C12.6667 8.17556 13.0644 7.77778 13.5556 7.77778H19.1111C19.6022 7.77778 20 8.17556 20 8.66667V11.3333C20 11.8244 19.6022 12.2222 19.1111 12.2222ZM14.2222 6.44444H9.77778C9.28667 6.44444 8.88889 6.04667 8.88889 5.55556V2.88889C8.88889 2.39778 9.28667 2 9.77778 2H14.2222C14.7133 2 15.1111 2.39778 15.1111 2.88889V5.55556C15.1111 6.04667 14.7133 6.44444 14.2222 6.44444ZM14.2222 18H9.77778C9.28667 18 8.88889 17.6022 8.88889 17.1111V14.4444C8.88889 13.9533 9.28667 13.5556 9.77778 13.5556H14.2222C14.7133 13.5556 15.1111 13.9533 15.1111 14.4444V17.1111C15.1111 17.6022 14.7133 18 14.2222 18Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0555208 0 0 0 0 0.232608 0 0 0 0 0.286146 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23ABD5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.15bae5f6.svg";
export { ForwardRef as ReactComponent };